import { Helmet } from 'react-helmet-async'; // ★これと
import gakusyuSidou from "../../img/gakusyuSidou.jpg";
import gyouzi from "../../img/gyouzi.jpg";
import canvas from "../../img/canvas.jpg";


const SupportPointHighSchool = () => {
    return (
        <div>
            {/* ★ここからHelmetの記述を追加します */}
            <Helmet>
                <title>TOSAYOBI高等学院 | 高知の通信制高校</title> {/* ←ここに希望するタイトルを設定 */}
                <meta name="description" content="TOSAYOBI高等学院の公式ウェブサイトです。高知で通信制高校をお探しの方へ。" />
                {/* 必要であれば、OGPタグなどもここに追加できます */}
                <meta property="og:title" content="TOSAYOBI高等学院" />
                <meta property="og:description" content="高知県で大学受験対策もできる通信制高校をお探しならTOSAYOBI高等学院。土佐塾予備校のノウハウで、一人ひとりに寄り添い高卒資格と志望大学合格をサポートします。" />
                <meta property="og:keywords" content="高知,予備校,入試,通信制" />
                {/* <meta property="og:image" content="ここにOGP画像のURL" /> */}
            </Helmet>
            <div>
                <h2 className='mt-52 p-5 pt-10 md:text-center flex-grow'>
                    <span className=' md:text-5xl  text-3xl  tracking-widest font-bold text-start'>生徒一人ひとりに適した学習・進学指導で<br />高校生の学びを<span style={{ color: 'darkred' }}>サポート</span></span>
                </h2>

                <section className="text-gray-600 body-font overflow-hidden">
                    <div className="container px-5 py-12 mx-auto">
                        <div className="lg:w-4/5 mx-auto flex flex-wrap">
                            <img src={gakusyuSidou} alt="学習指導" className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded" />
                            <div className="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
                                <h1 className="text-gray-900 text-4xl title-font font-medium mb-1"><span className='text-3xl pr-2' style={{ color: '#9b003f' }}>Point 01</span> 学習指導</h1>
                                <p className="leading-relaxed tracking-wides text-left">
                                    高校卒業に必要な基礎学力と大学受験に対応した応用力の育成をします。
                                    大学受験指導に長年の実績がある土佐塾予備校の講師の指導を受けることができます。希望者は当校で全国模試を受験することが可能です。その成績をもとに個別相談を行い、
                                    習熟度の確認や学習計画をたてていきます。
                                    また、進路について相談することもできるので、大学進学へのモチベーションを高めることができます。保護者の方に対しても定期面談を通じて生徒の学習状況や学校での様子・進路に関する情報を提供します。
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="container px-5 py-12 mx-auto">
                        <div className="lg:w-4/5 mx-auto flex flex-wrap">
                            <img src={gyouzi} alt="行事・課外活動" className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded" />
                            <div className="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
                                <h1 className="text-gray-900 text-4xl title-font font-medium mb-1"><span className='text-3xl pr-2' style={{ color: '#9b003f' }}>Point 02</span> 行事・課外活動</h1>
                                <p className="leading-relaxed tracking-wides text-left">
                                    校外での学習として、大学・専門学校の説明会や体験授業の参加、社会科見学を行っていきます。普段触れることのない分野や業界を知ることで、将来学びたい分野や目指したい職業を見つけるきっかけづくりになります。
                                    また、遠足やスポーツ大会などの校内行事を通して、生徒が中心となり活動を計画・実施することで主体性を高めていきます。
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="container px-5 py-12 mx-auto">
                        <div className="lg:w-4/5 mx-auto flex flex-wrap">
                            <img src={canvas} alt="キャンパスの様子" className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded" />
                            <div className="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
                                <h1 className="text-gray-900 text-4xl title-font font-medium mb-1"><span className='text-3xl pr-2' style={{ color: '#9b003f' }}>Point 03</span> キャンパスの様子</h1>
                                <p className="leading-relaxed tracking-wides text-left">
                                    １年生から３年生までの同じ教室で過ごすので、学年関係なく交流できます。
                                    学年や履修科目、進捗状況がそれぞれ違うので、各々が自分の学習を自分のペースで進めていきます。
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default SupportPointHighSchool;